import { FormControl, FormLabel, Select } from '@chakra-ui/react';

const SelectInput = ({ label, value, options, onChange, isDisabled }) => (
  <FormControl>
    <Select
      value={value}
      isDisabled={isDisabled}
      onChange={(e) => onChange(e.target.value)}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  </FormControl>
);

export default SelectInput;
